import { JobsState } from '../../store/state';
import { JobAction, JobsActions } from '../actions';

const initialState: JobsState = {
  data: null,
  isLoading: false,
  error: '',
};

const jobsReducer = (state: JobsState = initialState, action: JobAction): JobsState => {
  switch (action.type) {
    case JobsActions.LoadJobs:
      return {
        ...state,
        isLoading: true,
        error: null,
      };
    case JobsActions.LoadJobsSuccess:
      return {
        isLoading: false,
        error: null,
        data: action.payload,
      };
    case JobsActions.CancelJobError:
    case JobsActions.LoadJobsError:
      return {
        isLoading: false,
        error: action.payload,
        data: null,
      };
    case JobsActions.RemoveJobSuccess:
      return {
        isLoading: false,
        error: null,
        data: state?.data?.filter(task => task._id !== action.payload) ?? [],
      };
    case JobsActions.LoadJobSuccess:
    case JobsActions.ReassignJobSuccess:
      return {
        isLoading: false,
        error: null,
        data: [...(state?.data?.filter(task => task._id !== action.payload._id) ?? []), action.payload],
      };
    default:
      return state;
  }
};

export default jobsReducer;
